// Basics
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useMemo, useState } from 'react';

// MUI
import { LicenseInfo } from '@mui/x-license'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

// Me
import Login from "./auth/Login.js";
import Reset from "./auth/Reset";
import Dashboard from "./components/Dashboard";

LicenseInfo.setLicenseKey('cbff625d21c79b55c9897eb434c5088eTz0xMjE0NTYsRT0xNzk0MDA5NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=')

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    // background: {
    //   default: '#000',
    //   paper: '#000'
    // },
    // text: {
    //   primary: '#fff'
    // }
  },
  shape: {
    borderRadius: 12,  // default rounded value for all components
  },
  components: {
    MuiCard: {
      defaultProps: {
        variant: 'outlined', // default variant for Card components
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      }
    },
    MuiPaper: {
      defaultProps: {
        variant: 'outlined',
      }
    },
    // MuiDataGrid: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: '#000',
    //       color: '#fff',
    //     },
    //     columnHeader: {
    //       backgroundColor: '#000',
    //       outline: 'none',
    //     },
    //     row: {
    //       '&:hover': {
    //         backgroundColor: 'rgba(255,255,255,0.04) !important',
    //         boxShadow: '0 0 0 1px #666 inset',
    //       },
    //     },
    //   }
    // }
  }
});

const lightTheme = createTheme({
  palette: {
    mode: 'light',
  },
  shape: {
    borderRadius: 12,
  },
});

function App() {
  const [mode, setMode] = useState('dark');
  const theme = useMemo(() => (mode === 'dark' ? darkTheme : lightTheme), [mode]);

  const toggleMode = () => {
    setMode(prev => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Router>
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route exact path="/reset" element={<Reset />} />
              <Route exact path="/dashboard/*" element={<Dashboard themeMode={mode} onToggleTheme={toggleMode} />} />
            </Routes>
          </Router>
        </div>
      </ThemeProvider>
    </LocalizationProvider>
  );
}
export default App;
